/**
 * Espaço (tenant) ativo da sessão.
 *
 * O backend resolve o espaço na ordem: prefixo do caminho (`/t/<id>/`), header
 * `X-Tenant`, Host, e por fim o fallback de instalação única.
 *
 * As chamadas de API usam o HEADER. Assim nenhuma das centenas de chamadas
 * espalhadas pelas telas precisa saber que o prefixo existe — quem injeta é um
 * interceptor só.
 *
 * Por que não subdomínio: o Embedded Signup do WhatsApp roda o SDK da Meta na
 * página, e a Meta exige que a origem esteja cadastrada na configuração do
 * app. Um subdomínio por cliente obrigaria a editar isso à mão a cada espaço
 * novo. Com um host só, a origem é cadastrada uma vez.
 *
 * O header não autoriza nada sozinho: o backend recusa sessão emitida para
 * outro espaço.
 */

const CHAVE = 'tenant.ativo';

/** Id do espaço ativo, ou null. */
export function tenantAtivo() {
  // O caminho tem precedência: se o usuário abriu /t/7/..., é esse o espaço.
  const doCaminho = /^\/t\/(\d+)(?=\/|$)/.exec(window.location.pathname);
  if (doCaminho) return Number(doCaminho[1]);

  const salvo = Number(localStorage.getItem(CHAVE));
  return salvo || null;
}

export function definirTenantAtivo(id) {
  if (id) localStorage.setItem(CHAVE, String(id));
  else localStorage.removeItem(CHAVE);
}

export function limparTenantAtivo() {
  localStorage.removeItem(CHAVE);
}

/**
 * Faz a instância do axios enviar o espaço ativo em toda requisição.
 * Idempotente — registrar duas vezes não duplica o header.
 */
export function registrarHeaderDeTenant(instancia) {
  if (instancia.__tenantHeaderRegistrado) return instancia;

  instancia.interceptors.request.use((config) => {
    const id = tenantAtivo();
    if (id) {
      config.headers = config.headers || {};
      config.headers['X-Tenant'] = String(id);
    }
    return config;
  });

  // eslint-disable-next-line no-param-reassign
  instancia.__tenantHeaderRegistrado = true;
  return instancia;
}

export default { tenantAtivo, definirTenantAtivo, limparTenantAtivo, registrarHeaderDeTenant };
